import React, {useState} from "react";
import {NotFoundBlock} from "../components/NotFoundBlock/NotFoundBlock";


export const NotFound: React.FC = () => {
    return <div className="container">
        <NotFoundBlock />
    </div>
}
